<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade" [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="row m-0">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">{{'alert.alert_history' | translate}}</h2>
        <div class="row p-0 m-0">
            <div class="col-12 p-0 mb-2">
                <xng-breadcrumb separator=" > ">
                    <ng-container *xngBreadcrumbItem="let breadcrumb">
                        <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
                    </ng-container>
                </xng-breadcrumb>
            </div>
            <div class="col-12 p-0 mb-2 text-right">
                <button id="add_toggle" type="button" title="{{'general.export' | translate}}" class="btn btn-blue btn-h-blue mb-2 ml-2" (click)="exportAlertHistory()" *ngxPermissionsOnly="['Owner','Admin','SecurityAgent','Supervisor']">
                    {{'general.export' | translate}}
                </button>
            </div>
            <div class="col-12 p-0 mb-1">
                <div class="d-flex flex-row bd-highlight">
                    <div class="col-3 bd-highlight">
                        <!--group filter-->
                        <span>{{'alert.groups' | translate}}</span><br>
                        <div ngbDropdown class="d-inline-block w-100">
                            <button [disabled]="groupDisabled" class="btn btn-filter-size btn-outline-secondary bg-white text-dark w-100" title="{{ groupFilter | translate }}" ngbDropdownToggle>
                                {{ 'alert.group-filter' | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu class="dd-size">
                                <button ngbDropdownItem (click)="changeGroupFilterLabel(group.name)" title="{{ group.name }}" *ngFor="let group of group">
                                    {{ group.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 bd-highlight">
                        <!--alert type filter-->
                        <span>{{'alert.alert_type' | translate}}</span><br>
                        <div ngbDropdown class="d-inline-block w-100">
                            <button [disabled]="alertTypeDisabled" class="btn btn-filter-size btn-outline-secondary bg-white text-dark w-100" title="{{ alertTypeFilter | translate }}" ngbDropdownToggle>
                                {{ alertTypeFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu class="dd-size">
                                <button ngbDropdownItem (click)="changeAlertFilterLabel(alert.name)" title="{{ alert.name }}" *ngFor="let alert of alertTypes">
                                    {{ alert.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 bd-highlight">
                        <!--real or false alert filter-->
                        <span>{{'status' | translate}}</span><br>
                        <div ngbDropdown class="d-inline-block w-100">
                            <button class="btn btn-filter-size btn-outline-secondary bg-white text-dark w-100" title="{{ realFalseFilter.toLowerCase() | translate }}" id="realFalseType" ngbDropdownToggle>
                                {{ realFalseFilter.toLowerCase() | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="changeRealFalseFilterLabel(typeOfAlert)" title="{{ typeOfAlert.toLowerCase() | translate }}" *ngFor="let typeOfAlert of realFalseAlerts">
                                    {{ typeOfAlert.toLowerCase() | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 bd-highlight">
                        <!--late filter-->
                        <span>{{'alert.late' | translate}}</span><br>
                        <div ngbDropdown class="d-inline-block w-100">
                            <button class="btn btn-filter-size btn-outline-secondary bg-white text-dark w-100" title="{{'alert.select-late' | translate}}" id="lateFilter" ngbDropdownToggle>
                                {{ lateFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="changeLateFilterLabel('alert.late')" title="{{ 'alert.late' | translate }}">
                                    {{ 'alert.late' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeLateFilterLabel('alert.not-late')" title="{{ 'alert.not-late' | translate }}">
                                    {{ 'alert.not-late' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0">
                <div class="d-flex flex-row bd-highlight">
                    <div class="col-5"></div>
                    <div class="col-3 bd-highlight">
                        <!--date filter-->
                        <label class="mb-0" for="sd">{{'alert.created_date' | translate}}</label> − <label class="mb-0" for="ed">{{'alert.closed_on' | translate}}</label><br>
                        <form [formGroup]="dateRangeForm" (ngSubmit)="applyFilter()">
                            <mat-form-field class="mm-10 w-100">
                                <mat-date-range-input [rangePicker]="picker" formGroupName="picker" [min]='min' [max]='max'>
                                    <input id="sd" #fromInput matStartDate formControlName="startDate" matInput readonly>
                                    <input id="ed" #toInput matEndDate formControlName="endDate" matInput readonly>
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </form>
                    </div>
                    <div class="col-3 bd-highlight mb-3">
                        <!--datasource filter-->
                        <label class="mb-0" for="filter">{{'general.filter_name_alert' | translate}}</label>
                        <input id="filter" class="form-control border-secondary">
                    </div>
                    <div class="col-1 bd-highlight button-group text-nowrap">
                        <!--clear filter-->
                        <button tabindex="0" class="btn remove-filter-btn ml-1" title="" (click)="clearFilter()">
                            <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                        </button>
                        <!--apply filter-->
                        <button tabindex="0" class="btn apply-filter-btn ml-1" title="" (click)="applyFilter()">
                            <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <table class="border-top" mat-table [attr.role]="null" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="closedDate" matSortDirection="desc" matSortDisableClear>
            <!-- Alert Id Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> Id </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null"> {{alert.id}} </td>
            </ng-container>
            <!-- Alert Type Column -->
            <ng-container matColumnDef="alertTypeName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.type' | translate}} </th>
                <td class="text-break" mat-cell *matCellDef="let alert" [attr.role]="null"> {{ alert.alertTypeName }} </td>
            </ng-container>
            <!-- Created By Column -->
            <ng-container matColumnDef="profileFirstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.created_by' | translate}} </th>
                <td class="text-break" mat-cell *matCellDef="let alert" [attr.role]="null"> {{ alert.createdByName }} </td>
            </ng-container>
            <!-- Attended By Column -->
            <ng-container matColumnDef="closedFirstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.closed_by' | translate}} </th>
                <td class="text-break" mat-cell *matCellDef="let alert" [attr.role]="null"> {{alert.closedByName}} </td>
            </ng-container>
            <!-- Created Date Column -->
            <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.created_date' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null"> {{alertDate.convertUTCDateToLocalDate(alert.createdDate)}} </td>
            </ng-container>
            <!-- Closed Date Column -->
            <ng-container matColumnDef="closedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.closed_on' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null"> {{alertDate.convertUTCDateToLocalDate(alert.closedDate)}} </td>
            </ng-container>
            <!-- Canceled Alert Column -->
            <ng-container matColumnDef="canceled">
                <th class="centre" mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.canceled' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null">
                    <i *ngIf="alert.canceled" class="fa fa-exclamation-circle fa-2x text-danger red-text" title="{{'general.canceled' | translate}}"></i>
                </td>
            </ng-container>
            <!-- Late Alert Column -->
            <ng-container matColumnDef="late">
                <th class="centre" mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'alert.late' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null">
                    <i *ngIf="alert.late" [ngClass]="{'notLate': alert.late==='False', 'red-text': alert.late==='True'}" class="fa fa-circle ng-star-inserted" title="{{ (alert?.late==='True'?'general.yes':'No') | translate }}"><span class="info-txt"> {{ (alert?.late==='True'?'general.yes':'No') | translate }}</span></i>
                </td>
            </ng-container>
            <!-- Closed As Column -->
            <ng-container matColumnDef="falseAlert">
                <th class="centre" mat-header-cell *matHeaderCellDef [attr.role]="null" scope="col"> {{'alert.closed_as' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null">
                    <span *ngIf="alert.falseAlert === 1">{{'alert.false_alert' | translate}}</span>
                    <span *ngIf="alert.offZone>0">{{'alert.out_of_zone' | translate}}</span>
                    <span *ngIf="!alert.falseAlert&&alert.offZone==0">{{'alert.attended' | translate}}</span>
                </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="centre" [attr.role]="null" scope="col"> {{'general.actions' | translate}} </th>
                <td mat-cell *matCellDef="let alert" [attr.role]="null">
                    <div class="dropdown" ngbDropdown>
                        <button tabindex="0" ngbDropdownToggle class="btn btn-default dropdown-toggle cursor" title=""><i class="fa fa-ellipsis-v" title="{{'alert.actions_alert_no' | translate}} {{alert.id}}"></i></button>
                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-left">
                            <button ngbDropdownItem title="{{'general.view' | translate}}" [routerLink]="['view-alert-history',alert.id]" routerLinkActive="active"><i class="fa fa-eye"></i> {{'general.view' | translate}}</button>
                            <button ngbDropdownItem title="{{'alert.activity' | translate}}" [routerLink]="['/main/alertHistory/activity', alert.id]" routerLinkActive="active"><i class="fa fa-history"></i> {{'alert.activity' | translate}}</button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" [attr.role]="null"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.role]="null"></tr>
        </table>
        <mat-paginator #paginator [pageIndex]="pageIndex" [length]="totalLength" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
    </div>
</div>